var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage,"loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('DeleteModal',{attrs:{"show":_vm.show,"name":"Group"},on:{"close":_vm.onCancel,"submit":_vm.deletegroup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }